import { mergeObjectTypes } from '../cacheHelpers';

const CargoWeightType = {
  merge: mergeObjectTypes
};

export default CargoWeightType;
